export const CHAT_THREAD_HEIGHT = 360;

export const roundActionIconSx = {
  border: "1px solid #0b3d87",
  color: "#0b3d87",
  width: 40,
  height: 40,
};

export const chatThreadSx = {
  height: CHAT_THREAD_HEIGHT,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  borderRadius: 2,
  gap: 1.5,
  mb: 2,
  pr: 0.5,
};

export const chatInputSx = {
  fontFamily: "Rubik",
  backgroundColor: "#f0f5ff",
  borderRadius: 1,
  flex: 1,
  "& .MuiInputBase-input": { overflowY: "auto" },
};

export const chatDividerSx = { my: 0.5, borderColor: "#e3eaf5" };

export const chatPaginationChipSx = {
  fontFamily: "Rubik",
  borderColor: "#0b3d87",
  color: "#0b3d87",
};
